export default "__VITE_ASSET__DuGCBPng__"